import { apiClient } from "./apiClient";

export const emailConfigApi = {
    selectAll: () => apiClient.get(`email-config`)
}